import { render, staticRenderFns } from "./UserLeaveDetail.vue?vue&type=template&id=84b1a334"
import script from "./UserLeaveDetail.vue?vue&type=script&lang=js"
export * from "./UserLeaveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports